import { Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {FastenService} from '../../services/fasten.service';
import {ConfigService, FormSupportRequest} from '@shared-library';
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {FdkAlertComponent, FdkButtonComponent, FdkInputComponent, FdkTextareaComponent, FdkIllustrationComponent, FdkSpinnerComponent,} from 'fasten-design-kit';

@Component({
    selector: 'app-form-support-request',
    templateUrl: './form-support-request.component.html',
    styleUrls: ['./form-support-request.component.css'],
    standalone: true,
    imports: [
      CommonModule,
      ReactiveFormsModule,
      FormsModule,
      FdkSpinnerComponent,
      FdkAlertComponent,
      FdkInputComponent,
      FdkTextareaComponent,
      FdkButtonComponent,
      FdkIllustrationComponent
    ],
})
export class FormSupportRequestComponent implements OnInit {
  @Input() error?: string
  @Input() error_description?: string
  @Input() brand_id?: string
  @Input() portal_id?: string
  @Input() endpoint_id?: string
  @Input() org_connection_id?: string
  @Input() vault_profile_connection_id?: string
  @Input() external_id?: string
  @Input() external_state?: string
  @Input() request_id?: string

  formSupportRequest: FormSupportRequest = {} as FormSupportRequest

  loading: boolean = false
  submitSuccess: boolean = false
  errorMsg: string = ""

  get signInWarningDescription(): string {
    return [
      this.error ? `Type: ${this.error}` : '',
      this.error_description ? `Description: ${this.error_description}` : '',
    ].filter(Boolean).join(' ')
  }

  constructor(
    private router: Router,
    private configService: ConfigService,
    private vaultApi: FastenService,
  ) { }

  ngOnInit(): void {
    this.resetForm()
  }

  resetForm() {
    this.submitSuccess = false
    let requestForm = new FormSupportRequest()
    requestForm.email = this.configService.vaultProfileConfig$.email || ''
    requestForm.healthsystem_name = ''
    requestForm.request_content = ''

    this.formSupportRequest = requestForm
  }

  submitForm() {
    this.loading = true

    this.formSupportRequest.error = this.error
    this.formSupportRequest.error_description = this.error_description
    this.formSupportRequest.brand_id = this.brand_id
    this.formSupportRequest.portal_id = this.portal_id
    this.formSupportRequest.endpoint_id = this.endpoint_id
    this.formSupportRequest.org_connection_id = this.org_connection_id
    this.formSupportRequest.vault_profile_connection_id = this.vault_profile_connection_id
    this.formSupportRequest.external_id = this.external_id
    this.formSupportRequest.external_state = this.external_state
    this.formSupportRequest.request_id = this.request_id

    this.vaultApi.requestSupport(this.formSupportRequest).subscribe((resp: any) => {
        this.loading = false
        this.submitSuccess = true
        //show success toast? close modal?
      },
      (err)=>{
        this.loading = false
        console.error("an error occurred during issue submission",err)
        // Extract a readable error message
        let message = "An error occurred while submitting your issue. Please try again later.";
        try {
          if (err?.error) {
            if (typeof err.error === 'string') {
              message = err.error;
            } else if (typeof err.error?.message === 'string') {
              message = err.error.message;
            } else if (typeof err.message === 'string') {
              message = err.message;
            }
          } else if (typeof err?.message === 'string') {
            message = err.message;
          }
        } catch {}
        this.errorMsg = message
      })
  }

  dismiss(){
    this.router.navigateByUrl('dashboard')
  }

}
